$('.service-cloud-firstselect').change(function (e) {
    if ($(this).data('options') === undefined) {
        $(this).data('options', $('.service-cloud-secondselect option').clone());
    }
    var id = e.target.options[e.target.selectedIndex].getAttribute('id');
    var options = $(this).data('options').filter('[id=' + id + ']');
    $('.service-cloud-secondselect').html(options);
});
